import { DateTime } from 'luxon';
import { useDaysWithMissedPunch } from './useDaysWithMissedPunch';
import { useDaysWithMissedPunchCorrection } from './useDaysWithMissedPunchCorrection';
import { useDaysWithUpt } from './useDaysWithUpt';
export var useDaysWithAttention = function (_a) {
    var punchCorrections = _a.punchCorrections, getPunchesResponse = _a.getPunchesResponse, isPendingPunchesOnTimecardEnabled = _a.isPendingPunchesOnTimecardEnabled;
    var daysWithMissedPunch = useDaysWithMissedPunch({
        punchesTimeSegments: getPunchesResponse === null || getPunchesResponse === void 0 ? void 0 : getPunchesResponse.punchesTimeSegments,
        isPendingPunchesOnTimecardEnabled: isPendingPunchesOnTimecardEnabled
    });
    var daysWithMissedPunchCorrection = useDaysWithMissedPunchCorrection({
        punchCorrections: punchCorrections
    });
    var daysWithUpt = useDaysWithUpt({
        timeSegmentDailyAggregation: getPunchesResponse === null || getPunchesResponse === void 0 ? void 0 : getPunchesResponse.timeSegmentDailyAggregation
    });
    var dateStrings = new Set();
    for (var _i = 0, daysWithMissedPunch_1 = daysWithMissedPunch; _i < daysWithMissedPunch_1.length; _i++) {
        var dateTime = daysWithMissedPunch_1[_i];
        dateStrings.add(dateTime.startOf('day').toISO());
    }
    for (var _b = 0, daysWithMissedPunchCorrection_1 = daysWithMissedPunchCorrection; _b < daysWithMissedPunchCorrection_1.length; _b++) {
        var dateTime = daysWithMissedPunchCorrection_1[_b];
        dateStrings.add(dateTime.startOf('day').toISO());
    }
    for (var _c = 0, daysWithUpt_1 = daysWithUpt; _c < daysWithUpt_1.length; _c++) {
        var dateTime = daysWithUpt_1[_c];
        dateStrings.add(dateTime.startOf('day').toISO());
    }
    return Array.from(dateStrings).map(function (date) { return DateTime.fromISO(date); });
};
